// Currency and localization API

const EXCHANGE_RATES = {
  USD: { name: 'USD', symbol: '$', rate: 1 },
  RUB: { name: 'RUB', symbol: '₽', rate: 97.50 } // Example rate
};

export const currencyApi = {
  getExchangeRates: async () => {
    // Simulate API call to get current rates
    await new Promise(resolve => setTimeout(resolve, 200));
    return {
      success: true,
      data: EXCHANGE_RATES
    };
  },

  getRate: async (currency) => {
    await new Promise(resolve => setTimeout(resolve, 100));
    const rate = EXCHANGE_RATES[currency];
    if (!rate) return { success: false, error: 'Currency not found' };
    return { success: true, data: rate };
  },

  convertCurrency: (amount, fromCurrency = 'USD', toCurrency = 'RUB') => {
    const fromRate = EXCHANGE_RATES[fromCurrency]?.rate || 1;
    const toRate = EXCHANGE_RATES[toCurrency]?.rate || 1;
    return (amount / fromRate) * toRate;
  }
};

export const formatCurrency = (amount, currency = 'USD') => {
  const rate = EXCHANGE_RATES[currency];
  if (!rate) return amount;

  const convertedAmount = (amount / EXCHANGE_RATES.USD.rate) * rate.rate;
  
  return new Intl.NumberFormat(currency === 'RUB' ? 'ru-RU' : 'en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: currency === 'RUB' ? 0 : 2,
    maximumFractionDigits: currency === 'RUB' ? 0 : 2
  }).format(convertedAmount);
};

export default currencyApi;
